import Blue from "~/dfwjobs/core";

new Blue({
	name: 'Form Validate',
	selector: ".form--validate",
	setup(form) {
		this.$validate(form);
	}
});